<template>
  <vx-card class="upgrade-list vs-space-table">
    <vs-table
      :data="showList"
    >
      <div slot="header" class="top w-full">
        <slot name="helptext" />
        <vx-form class="vx-row">
          <form-item label="搜索" class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input class="w-full" placeholder="输入客户ID、昵称、手机号、邮箱、企业名称" v-model="query.keyword"
                      @keypress.enter="fetchList(1)"/>
          </form-item>
          <form-item class="vx-col sm:w-1/3 w-full mb-2">
            <vs-button class="mr-3 mb-2">
              查询
            </vs-button>
            <vs-button to="/customer/create" color="primary" type="border"
                       class="mb-4 mr-4 cursor-pointer items-center justify-between font-medium text-base text-primary border border-solid border-primary">
              <icon icon="PlusIcon" svgClasses="h-4 w-4" style="top: 2px"/>
              新建
            </vs-button>
          </form-item>
        </vx-form>
      </div>
      <template slot="thead">
        <vs-th>UID</vs-th>
        <vs-th>用户名</vs-th>
        <vs-th>称呼</vs-th>
        <vs-th>企业名称</vs-th>
        <vs-th>企业Logo</vs-th>
        <vs-th>邮箱</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{tr.uid}}</vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.userName}}</vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.nickName}}</vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.name}}</vs-td>
          <vs-td class="whitespace-no-wrap"><img class="avatar" :src="tr.logo" alt=""></vs-td>
          <vs-td>{{tr.email}}</vs-td>
          <vs-td class="whitespace-no-wrap">
            <router-link :to="'/product/list?customer=' + tr.uid" v-if="$acl.check('customer_edit')" class="mr-5">查看客户商品</router-link>
            <router-link :to="'/order/list?customer=' + tr.uid" v-if="$acl.check('customer_edit')" class="mr-5">查看客户订单</router-link>
            <router-link :to="'/customer/edit/' + tr.uid" v-if="$acl.check('customer_edit')" class="mr-5">编辑</router-link>
            <span class="text-danger cursor-pointer" @click="willRemove(tr)" v-if="$acl.check('customer_edit')">删除</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>
<script>
  export default {
    data() {
      return {
        // list: [],
        // total: 0,
        query: {
          keyword: '',
          limit: 100000,
          page: 1,
        },
      }
    },
    $computed: {
      list: 'user.customers',

    },
    computed: {
      showList() {
        if (!this.query.keyword) {
          return this.list
        }
        return this.list.filter(user => {
          return !!~`${user.uid}${user.nickName}${user.phone}${user.email}${user.name}`.indexOf(this.query.keyword)
        })
      },
    },
    mounted() {
      this.fetchList(1)
    },
    methods: {
      // onPageChange(p) {
      //   this.fetchList(p)
      // },
      async fetchList() {
        await this.$s.user.fetchCustomer(true)
        // if (page) {
        //   this.query.page = page
        // }
        // const q = {
        //   keyword: this.query.keyword,
        //   offset: (this.query.page - 1) * this.query.limit,
        //   limit: this.query.limit,
        // }
        // const {list, total} = await this.$s.user.fetchCustomer()
        // this.list = list
        // this.total = total
      },
      willRemove(item) {
        this.$confirm({
          color: 'danger',
          title: '确定删除该客户？',
          text: '删除后将不可恢复，是否确定',
          accept: async () => {
            await this.$s.user.remove(item.uid)
            this.list = this.list.filter(x => x.uid != item.uid)
          }
        })
      },
    },
  }
</script>
<style scoped>
  .avatar {
    width: 100px;
  }
</style>